import { Component, Input } from '@angular/core';
import { usersRoute } from 'src/app/app-routing.module';
import { UserDetailLinkModel } from 'src/app/common-components/detail-links/models/user-detail-link.model';

@Component({
    selector: 'update-details',
    templateUrl: './update-details.component.html',
    standalone: false
})
export class UpdateDetailsComponent {
   @Input() createUser: UserDetailLinkModel | null;

   @Input() createDate: string | null;

   @Input() updateUser: UserDetailLinkModel | null;

   @Input() updateDate: string | null;

   usersRoute = usersRoute;
}
